import { actions } from "../../../../../common/constants";

const initialState = {
  isSubmitting: false,
  isFormInvalid: false,
  isLoggingOut: false,
  isLoggedIn: false,
  data: null,
};

const actionMap = {
  [actions.ADMIN_LOGIN_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    isLoggedIn: false,
  }),
  [actions.ADMIN_LOGIN_SUCCESS]: (state, { result }) => ({
    ...state,
    isSubmitting: false,
    isFormInvalid: false,
    isLoggedIn: true,
    data: result.data,
  }),
  [actions.ADMIN_LOGIN_FAILURE]: (
    state,
    {
      error: {
        response: { status },
      },
    }
  ) => ({
    ...state,
    isFormInvalid: !!status,
    isSubmitting: false,
    isLoggedIn: false,
  }),

  [actions.RESET_LOGIN_STATE]: (state) => ({ ...state, isFormInvalid: false }),

  [actions.ADMIN_LOGOUT_REQUEST]: (state) => ({ ...state, isLoggingOut: true }),
  [actions.ADMIN_LOGOUT_SUCCESS]: (state) => ({
    ...state,
    isLoggingOut: false,
  }),
  [actions.ADMIN_LOGOUT_FAILURE]: (state) => ({
    ...state,
    isLoggingOut: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};



// WEBPACK FOOTER //
// ./client/react/Admin/store/reducers/authentication.js